import {BASE_PATH, BASE_PATH_EXTENSION, BASE_PATH_EXTENSION_ADMIN} from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/provider-record`;

export async function showProviderRecordApi() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/list`, null, config)
}

export async function addProviderRecord(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/add-record`, props, config)
}

export async function deleteProviderRecord(id) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.delete(`${urlBase}/delete-record/${id}`, config)
}

export async function exportTransaction(props) {
    const config = {
        headers: {
            'Authorization': `Bearer ${getToken()?.primaryUser?.token}`,
            'Content-Type': 'application/json'
        },
        responseType: 'blob' // ← necesario para manejar ficheros
    };

    return axios.post(`${urlBase}/export`, props, config);
}




